import { render, staticRenderFns } from "./rubric_library.vue?vue&type=template&id=16db4d8e&scoped=true&"
import script from "./rubric_library.vue?vue&type=script&lang=js&"
export * from "./rubric_library.vue?vue&type=script&lang=js&"
import style0 from "./rubric_library.vue?vue&type=style&index=0&id=16db4d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db4d8e",
  null
  
)

export default component.exports